import { ComparisonTable } from '../ComparisonTableTypes';

/**
 * The default comparison table for pricing summary. This can be
 * altered/extended for experiments as needed.
 */
const SummaryComparisonTable: ComparisonTable = [
  {
    title: 'Essentials',
    features: {
      unlimited_surveys: { title: 'Unlimited surveys' },
      unlimited_questions: { title: 'Unlimited questions' },
      unlimited_responses: { title: 'Unlimited responses' },
      unlimited_collectors: { title: 'Unlimited number of collectors' },
    },
  },
  {
    title: 'Support',
    features: {
      email_support: { title: '24/7 expedited email support' },
      phone_support: { title: 'Phone support' },
      customer_success_manager: { title: 'Customer Success Manager' },
    },
  },
  {
    title: 'Building Surveys',
    features: {
      essential_question_types: { title: 'Essential question types' },
      survey_templates: { title: 'Expert, pre-written survey templates' },
      quizzes: { title: 'Quizzes with custom feedback' },
      question_page_skip_logic: { title: 'Question and page skip logic' },
      question_page_randomization: { title: 'Question and page randomization' },
      a_b_test_question: { title: 'A/B test question type' },
      custom_variables: { title: 'Custom variables' },
      file_upload: { title: 'File upload' },
      accept_payments: { title: 'Accept payments' },
      adv_branching_and_piping: { title: 'Advanced brnaching and piping' },
      block_randomization: { title: 'Block randomization' },
      multilingual_surveys: { title: 'Multilingual surveys' },
    },
  },
  {
    title: 'Branding & Customization',
    features: {
      custom_logo_colors_url: { title: 'Custom logo, colors and survey URL' },
      custom_email_invites: { title: 'Custom HTML email invitations' },
      remove_footer: { title: 'Remove SurveyMonkey footer' },
      custom_subdomain: { title: 'Custom subdomain' },
      custom_email: { title: 'Custom email domain' },
      custom_terms: { title: 'Custom Terms of Use' },
      custom_question_bank: { title: 'Custom question bank' },
    },
  },
  {
    title: 'Response Collection',
    features: {
      recurring_surveys: { title: 'Recurring surveys' },
      require_answer_completion: { title: 'Require answer completion' },
      survey_end_date: { title: 'Set survey end date' },
      view_ip_addresses: { title: "View respondent's IP address" },
      confirmation_email: { title: 'Confirmation email to respondents' },
      change_survey_url: { title: 'Change survey URL' },
      website_redirect: { title: 'Website redirect' },
      sms_offline_collection: { title: 'SMS and offline device collection' },
      smart_notifications: { title: 'Smart notifications' },
      hippa_compliance: { title: 'HIPPA-compliane available' },
    },
  },
  {
    title: 'Analysis',
    features: {
      data_trends: { title: 'Data trends' },
      filter_and_compare: { title: 'Filter and compare results' },
      custom_reports: { title: 'Generate custom charts & reports' },
      statistical_significance: { title: 'Statistical significance' },
      data_exports: { title: 'Data exports (CSV, PDF, PPT, XLS, and SPSS)' },
      word_clouds: { title: 'Word clouds' },
      results_dashboards: { title: 'Create dashboards to compare results' },
      industry_benchmarks: { title: 'SurveyMonkey industry benchmarks' },
      sentiment_analysis: { title: 'Sentiment analysis' },
      crosstabs: { title: 'Crosstabs' },
    },
  },
  {
    title: 'Collaboration',
    features: {
      build_together: { title: 'Build surveys together' },
      survey_sharing_with_editing: {
        title: 'Survey sharing with full editing capabilities',
      },
      fine_permission_controls: {
        title: 'Fine permission controls for survey designs and results',
      },
      team_analyze: {
        title: 'Let team emembers analyze, filter, and export results',
      },
      shared_templates: { title: 'Shared template and asset library' },
      add_reassign_accounts: { title: 'Add or reassign accounts at any time' },
      admin_dashboard: { title: 'Admin dashboard' },
      roles_workgroups: { title: 'Roles and workgroups' },
      global_settings: { title: 'Global settings' },
    },
  },
  {
    title: 'Integrations',
    features: {
      free_integrations: {
        title: 'Free integrations with popular collaboration apps',
      },
      direct_api: { title: 'Direct API access' },
      api_limits: { title: 'Custom API limits' },
      bi_integrations: {
        title: 'Integrations with Salesforce, Marketo, Eloqua, Tableau, and PowerBI**',
      },
    },
  },
  {
    title: 'Compiance and Governance',
    features: {
      password_protected: { title: 'Password-protected surveys' },
      iso_27001: { title: 'ISO-27001' },
      accessible: { title: 'Fully accessible, 508 compliant surveys' },
      activity_tracking: { title: 'Activity tracking' },
      custom_terms: { title: 'Custom Terms of Use' },
      hippa_compliance: { title: 'HIPPA-compliant features**' },
      single_signon: { title: 'Single sign-on (SSO)' },
      account_control: { title: 'Account control' },
    },
  },
];

export default SummaryComparisonTable;
